import { useEffect, useState } from 'react';
import { IconSearch } from '@tabler/icons-react';
import { Input } from '../ui/Input.js';
import type { PatchFn } from './types.js';

type Props = {
  value: string;
  onPatch: PatchFn;
};

/** Debounced full-text search input. Writes `q` to the URL ~300ms after typing stops. */
export function SearchBox({ value, onPatch }: Props) {
  const [text, setText] = useState(value);

  // Keep the field in sync when the URL changes externally (back/forward, clear all).
  useEffect(() => {
    setText(value);
  }, [value]);

  useEffect(() => {
    const id = setTimeout(() => {
      const next = text.trim();
      if (next !== value.trim()) onPatch({ q: next || undefined });
    }, 300);
    return () => clearTimeout(id);
    // Only re-run when the typed text changes; value/onPatch are read inside.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);

  return (
    <div className="relative">
      <IconSearch
        size={18}
        className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-soft pointer-events-none"
      />
      <Input
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Search courses, providers, CRICOS or ANZSCO codes…"
        className="pl-10"
        aria-label="Search courses"
      />
    </div>
  );
}
